// permissionsAsync.js
import { getUser } from "./auth";
import { getUmatPermissions, fetchAndStoreUmatPermissions } from "./wkCommon";

const _permsCache = new Map();   // email -> { status, value }
const _inflight = new Map();     // email -> Promise

function _key(email) { return String(email ?? ""); }

export function getCachedPerms(email) {
  const entry = _permsCache.get(_key(email));
  if (entry && entry.status === "ok" && entry.value) return entry.value;
  return null;
}

async function _fetchAndCache(email) {
  const key = _key(email);
  if (_inflight.has(key)) return _inflight.get(key);
  const p = (async () => {
    try {
      // lalu di _fetchAndCache replace the raw = await getUmatPermissions(email);
      const raw = await fetchAndStoreUmatPermissions(email);

      // normalize shape: always arrays
      const normalized = {
        direct: Array.isArray(raw?.direct) ? raw.direct : [],
        fromRoles: Array.isArray(raw?.fromRoles) ? raw.fromRoles : [],
        all: Array.isArray(raw?.all) ? raw.all : [],
      };
      _permsCache.set(key, { status: "ok", value: normalized });
      return normalized;
    } catch (err) {
      _permsCache.set(key, { status: "err", value: { direct: [], fromRoles: [], all: [] } });
      throw err;
    } finally {
      _inflight.delete(key);
    }
  })();
  _inflight.set(key, p);
  return p;
}

/**
 * Async check: waits for permissions (deduped) and returns boolean.
 */
export async function hasUmatPermissionAsync(email, permissionName) {
  if (!permissionName) return false;
  const target = email ?? (getUser()?.LoginEmail ?? getUser()?.email);
  if (!target) return false;
  // check cache first
  const cached = getCachedPerms(target);
  if (cached && Array.isArray(cached.all)) return cached.all.includes(permissionName);
  // fetch and then check
  try {
    const perms = await _fetchAndCache(target);
    const list = Array.isArray(perms?.all) ? perms.all : [];
    return list.includes(permissionName);
  } catch (e) {
    console.warn("hasUmatPermissionAsync: fetch failed", e);
    return false;
  }
}

/** Optional: force-refresh */
export async function refreshUmatPermissions(email) {
  const target = email ?? (getUser()?.LoginEmail ?? getUser()?.email);
  if (!target) return null;
  return _fetchAndCache(target);
}